import AgentInstances from '@/components/agent/agentInstances';
import { Box } from '@mui/material';

type Props = { maxHeight: number };
const MyAgentInstances = ({ maxHeight }: Props) => {
  return (
    <Box sx={{ height: `${maxHeight}px` }}>
      <AgentInstances />
    </Box>
  );
};

export default MyAgentInstances;
